var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{staticStyle:{"padding-bottom":"8px !important"},attrs:{"no-title":"","allowed-dates":_vm.type === 'startDate' ? _vm.startDateAllowed : _vm.endDateAllowed,"value":_vm.value},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }